/* eslint-disable */

// import {confettiExplode} from './js/confetti.js';
import { gsap } from "gsap/all";
import  SplitText  from "../js/SplitText.min.js";
import drawSVG from "../js/DrawSVGPlugin.min.js";
// import barba from '@barba/core';
gsap.registerPlugin(drawSVG);

import'../js/header.js';
import'../js/links.js';
import'../js/mobilemove.js';
import '../js/confetti.js';
import CountDownTimer from '../components/CountDownTimer.js';

export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    const $successPage = document.getElementById('successPage');
    const $mainPageContent = document.getElementById('mainPageContent');
    // const $submitBtn = document.querySelector('#submitBtn');
    // const $successBackBtn = document.querySelector('#successBackBtn');

    // *******************************************
    // * Page INIT
    // *******************************************

    const init = () => {

      firstLoadAni();

      if(navigator.userAgent.toLowerCase().indexOf('safari/') > -1){
        var $bgEl =  document.getElementById('bgFadeIn');
        $bgEl.classList.add('safari-browser');
      }
    };

    // *******************************************
    // * First Paint
    // *******************************************

    const firstLoadAni = () => {

      setTimeout( () => {
        gsap.to( '#bgFadeIn' , 0.4 , {
          opacity: 1,
          ease: 'power1.in'
        })

        setTimeout( () => {
          gsap.to( '.app-wrapper' , 0.5 , {
            opacity: 1,
            ease: 'power1.in',
          })
          successPageAnimate();
          CountDownTimer();
        },350);

      },0);

    }

    // *******************************************
    // * Succes page
    // *******************************************
    const aniConf = {
      stagger: 0.04, // 0.05
      opacity: 0 ,
      scale: 0,
      transformOriginIn: "0% 50% -50",
      transformOriginOut: "50% 50% -50",
      rotationXIn: -180,
      rotationXOut: 180,
      posYin: 80,
      posYout: -80,
      ease: 'power4.inOut',
      // inTime: 0.9,
      // outTime: 0.9,
      inTime: 0.8,
      outTime: 0.8,
      // outDelay: '-=1.1',
      // nextInDelay: '+=2.5',
      outDelay: '-=0.8',
      nextInDelay: '+=1.8',
      initialDelay: 0,
    };


    const successPageAnimate = () => {
      if (document.body.classList.contains('thank-you') || document.body.classList.contains('thank-you-two')) {

        gsap.to( '#bgFadeIn' , 0.4 , {
          opacity: 1,
          ease: 'power1.in'
        })
        gsap.to($successPage , 0,  {
          zIndex: 1,
        })
        gsap.to($successPage , 0.4,  {
          opacity: 1,
          ease: "power2.in",
          delay: 0.2,
        })

        const $successTxtAni = document.getElementById('succTxtAni');
        gsap.set($successTxtAni, {perspective: 400});
        const aniTextsSplitted =  new SplitText( $successTxtAni , {type: "words, lines, chars"});
        gsap.from( aniTextsSplitted.chars, aniConf.inTime, { stagger: { each: aniConf.stagger }, opacity:aniConf.opacity, y:aniConf.posYin, scale:aniConf.scale, ease: aniConf.ease, rotationX: aniConf.rotationXIn, transformOrigin:aniConf.transformOriginIn , delay: 0 } )

        // setTimeout( () => {
        //   confettiExplode();
        // } , 700) // confetti delay
      }
    }

    const backToMainPage = () => {
      gsap.to($successPage , 0.5,  {
        opacity: 0,
        ease: "power2",
        zIndex: -1,
      })
      gsap.to($mainPageContent , 0.5,  {
        opacity: 1,
        ease: "power2",
        delay: 0.2,
      })
    }

    init();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/thank-you.js